/* eslint-disable max-lines */
import React, { useContext, useEffect, useRef, useState } from 'react';
import {
    ClickAwayListener,
    FormControl,
    Input,
    MenuItem,
    MenuList,
    Popper,
    Paper,
    Fade
} from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { makeStyles, Tooltip } from '@material-ui/core';
import { convertFarsiDigitToEnglish } from '../../../utils/converter';
import MessagesContext from '../../../contexts/messagesContext';
const commonStyle = () => ({
    timeOptionItem: {
        justifyContent: 'center',
        fontSize: '1.1em',
        lineHeight: '2em',
        cursor: 'pointer',
        padding: '5px',
        '&:hover': {
            backgroundColor: '#e6e6e6'
        }
    },
    popper: {
        background: 'white',
        zIndex: '999999',
        maxHeight: '200px',
        overflow: 'auto',
        boxShadow: '0 2px 14px 0 rgba(0, 0, 0, 0.22)',
        direction: 'ltr',
        borderRadius: '6px'
    }
});
const styles = makeStyles((theme) => ({
    rootFormControl: {
        width: '180px',
        position: 'relative',
        paddingLeft: '30px',
        paddingBottom: '26px',
        [theme.breakpoints.down(1025)]: {
            width: '100%',
            paddingLeft: 'unset'
        }
    },
    label: {
        color: '#767676',
        paddingBottom: '8px',
        fontFamily: 'mainFont'
    },
    timeFormContainer: {
        display: 'flex'
    },
    inputRoot: {
        border: 'solid 1px #bbbbbb',
        backgroundColor: '#ffffff',
        // borderRadius: (props) => (props.isMobile ? '4px' : '9px'),
        direction: 'ltr',
        width: '150px',
        '&:focus-within': {
            border: 'solid 1px #1b90fa'
        },
        [theme.breakpoints.down(1025)]: {
            width: '100%'
        }
    },
    input: {
        paddingRight: '10px',
        paddingLeft: '10px',
        color: '#3d454a',
        lineHeight: '1.67em',
        height: '1.67em',
        '&:disabled': {
            backgroundColor: '#fafbfc',
            borderRadius: '6px'
        }
    },
    errorContainer: {
        padding: '3px 7px',
        fontSize: '0.9em',
        color: 'red'
    },
    ...commonStyle({ big: true })
}));
const noStyles = makeStyles({
    ...commonStyle(),
    input: {
        width: '80px',
        padding: '3px 0',
        border: 'solid 1px white',
        '&:focus': {
            border: 'solid 1px rgba(27, 144, 250, 0.7)',
            borderRadius: '4px'
        }
    }
});
export default function TimeSelect(props) {
    const { messages } = useContext(MessagesContext);
    let classes;
    if (props.noStyle) {
        classes = noStyles();
    } else {
        classes = styles();
    }
    const [time, setTime] = useState(props.value ? props.value : '');
    const [open, setOpen] = useState(false);
    const timeRegex = /^([0-1]?[0-9]|2[0-3])(:[0-5][0-9]?)?()?(AM|PM)?$/g;
    const times = [];
    for (let i = 0; i < 24; i++) {
        for (let j = 0; j < 4; j++) {
            if (i === 0) {
                times.push({
                    label: 12 + ':' + (15 * j === 0 ? '00' : 15 * j) + ' AM',
                    value: '00:' + (15 * j === 0 ? '00' : 15 * j)
                });
            } else if (i < 12) {
                times.push({
                    label: i + ':' + (15 * j === 0 ? '00' : 15 * j) + ' AM',
                    value: i + ':' + (15 * j === 0 ? '00' : 15 * j)
                });
            } else {
                times.push({
                    label:
                        (i - 12 === 0 ? 12 : i - 12) + ':' + (15 * j === 0 ? '00' : 15 * j) + ' PM',
                    value: i + ':' + (15 * j === 0 ? '00' : 15 * j)
                });
            }
        }
    }
    for (let i = 0; i < 32; i++) {
        times.push(times[i]);
        times.shift();
    }
    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState(messages.validations.incorrectValue);
    const handleChange = (e) => {
        setTime(e.target.value);
        setErrorText(messages.validations.incorrectValue);
        setError(false);
        const value = convertFarsiDigitToEnglish(e.target.value);
        if (value) {
            const found = times.find(
                (time) => time.label.startsWith(value) || time.value.startsWith(value)
            );
            const foundIndex = times.indexOf(found);
            if (optionContainerRef.current) {
                optionContainerRef.current.scrollTop = foundIndex * 40;
            }
            if (timeRegex.test(value)) {
                props.setTime(value);
                setError(false);
            } else {
                props.setTime(null);
                setError(true);
            }

            setOpen(true);
        } else {
            props.setTime(null);
            setError(false);
        }
    };
    const openTimeOptions = () => {
        setOpen(true);
    };
    const handleSelectTime = (value, label) => {
        setErrorText(messages.validations.incorrectValue);
        setError(false);
        setTime(label);
        setOpen(null);
        props.setTime(value);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    const handleListKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    };
    const optionContainerRef = useRef();
    const anchorRef = useRef();
    // const prevOpen = useRef(open);
    // useEffect(() => {
    //     if (prevOpen.current === true && open === false) {
    //         anchorRef.current.focus();
    //     }

    //     prevOpen.current = open;
    // }, [open]);
    useEffect(() => {
        if (props.errors) {
            setError(true);
            setErrorText('ساعت را همراه زمان وارد کنید');
        }
    }, [props.errors]);
    return (
        <FormControl classes={{ root: classes.rootFormControl }}>
            {props.label && (
                <label className={classes.label} htmlFor={props.id || props.name}>
                    {props.label}
                    {props.optionalToUse && (
                        <span style={{ color: '#bbbbbb' }}>
                            &nbsp;
                            <span>(</span>
                            <span>{messages.optional}</span>
                            <span>)</span>{' '}
                        </span>
                    )}
                </label>
            )}
            <div className={classes.timeFormContainer}>
                <Tooltip
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={errorText}
                    open={error}
                    placement="top-start"
                >
                    <Input
                        classes={{
                            root: classes.inputRoot,
                            input: classes.input
                        }}
                        value={time}
                        onChange={handleChange}
                        onFocus={openTimeOptions}
                        onClick={openTimeOptions}
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                    />
                </Tooltip>
                <Popper
                    className={classes.popper}
                    open={open}
                    anchorEl={anchorRef.current}
                    role="menu"
                    transition
                    disablePortal
                    ref={optionContainerRef}
                >
                    {({ TransitionProps, placement }) => (
                        <Fade
                            timeout={150}
                            {...TransitionProps}
                            style={{
                                transformOrigin:
                                    placement === 'bottom' ? 'center top' : 'center bottom'
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList autoFocusItem={open} onKeyDown={handleListKeyDown}>
                                        {times.map((time, key) => (
                                            <MenuItem
                                                className={classes.timeOptionItem}
                                                onClick={() =>
                                                    handleSelectTime(time.value, time.label)
                                                }
                                                key={key}
                                                value={time.value}
                                            >
                                                {time.label}
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Fade>
                    )}
                </Popper>
            </div>
        </FormControl>
    );
}
TimeSelect.propTypes = {
    id: PropTypes.any,
    name: PropTypes.string,
    label: PropTypes.string,
    selectItems: PropTypes.array,
    setTime: PropTypes.func,
    errors: PropTypes.bool,
    value: PropTypes.string,
    optionalToUse: PropTypes.bool,
    noStyle: PropTypes.bool
};
